import * as types from "./patient.action.types";

export default {
  [types.GET_PatientUsers]: (state, res) => {
    state.GET_PatientUsers = res;
  },
};
